// AuthContext.tsx
import { createContext, useContext, useState } from "react";
import { Role } from "../types/types";

interface AuthContextType {
  refreshKey: boolean;
  refreshAction: () => void;
  isWorker: boolean;
  isWorkerAction: (flag:boolean) => void;
  roles: Role[];
  setRolesAction: (rolse:Role[]) => void;
}


const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [refreshKey, setRefreshKey] = useState(false);
  const [isWorker, setIsWorker] = useState(false);
  const [roles, setRoles] = useState<Role[]>([]);

  const refreshAction = () => {
    setRefreshKey((prev) => !prev); // ✅ 토글만 하면 됨
  };

  const isWorkerAction = (flag:boolean) => {
    setIsWorker(flag); // ✅ 토글만 하면 됨
  };

  const setRolesAction = (rolse:Role[]) => {
    setRoles(rolse);
  }

  return (
    <AuthContext.Provider value={{ refreshKey, refreshAction, isWorker, isWorkerAction, roles, setRolesAction}}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth는 AuthProvider 내부에서만 사용해야 합니다.");
  return context;
};
